import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown, Phone } from 'lucide-react';
import { Button } from './ui/Button';
import { locations, GLOBAL_PHONE } from '../data/locations';
import { programs } from '../data/programs';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLocationsDropdownOpen, setIsLocationsDropdownOpen] = useState(false);
  const [isProgramsDropdownOpen, setIsProgramsDropdownOpen] = useState(false);
  const [isParentsDropdownOpen, setIsParentsDropdownOpen] = useState(false);
  const navItems = [{
    label: 'Home',
    path: '/'
  }, {
    label: 'Programs',
    path: '/programs',
    hasDropdown: true,
    dropdownType: 'programs'
  }, {
    label: 'Locations/Schedules',
    path: '/locations',
    hasDropdown: true,
    dropdownType: 'locations'
  }, {
    label: 'Instructors',
    path: '/instructors'
  }, {
    label: 'Parents Hub',
    path: '#',
    hasDropdown: true,
    dropdownType: 'parents'
  }, {
    label: 'Contact',
    path: '/contact'
  }];
  const parentsDropdownItems = [{
    label: 'Schedules',
    path: '/locations'
  }, {
    label: 'FAQs',
    path: '/faqs'
  }, {
    label: 'Forms & Videos',
    path: '/forms-videos'
  }, {
    label: 'Merch',
    path: '/merch'
  }];
  return <>
      {/* Static Eyebrow Bar */}
      <div className="bg-slate-900 text-white" data-id="element-266">
        <div className="py-2 px-4" data-id="element-267">
          <p className="text-xs text-center font-medium" data-id="element-268">
            Taekwondo & Martial Arts Classes Across Michigan • 6 Locations for
            Kids, Teens & Adults
          </p>
        </div>
      </div>

      {/* Fixed Main Header */}
      <header className="sticky top-0 z-50 bg-white border-b border-slate-100 shadow-sm" data-id="element-269">
        <div className="mx-auto px-4 sm:px-6 lg:px-8" style={{
        maxWidth: '1200px'
      }} data-id="element-270">
          <div className="flex justify-between items-center h-20" data-id="element-271">
            {/* Logo */}
            <div className="flex-shrink-0" data-id="element-272">
              <Link to="/" data-id="element-273">
                <img src="https://cdn.magicpatterns.com/uploads/5Qiz8EjgR1snEvxNqavy5Z/logo_copy.png" alt="Che Ko Martial Arts" className="h-[72px] w-auto" data-id="element-274" />
              </Link>
            </div>

            {/* Desktop Navigation - Centered */}
            <nav className="hidden xl:flex space-x-6 items-center" data-id="element-275">
              {navItems.map(item => item.hasDropdown ? <div key={item.path} className="relative" onMouseEnter={() => {
              if (item.dropdownType === 'locations') {
                setIsLocationsDropdownOpen(true);
              } else if (item.dropdownType === 'programs') {
                setIsProgramsDropdownOpen(true);
              } else if (item.dropdownType === 'parents') {
                setIsParentsDropdownOpen(true);
              }
            }} onMouseLeave={() => {
              if (item.dropdownType === 'locations') {
                setIsLocationsDropdownOpen(false);
              } else if (item.dropdownType === 'programs') {
                setIsProgramsDropdownOpen(false);
              } else if (item.dropdownType === 'parents') {
                setIsParentsDropdownOpen(false);
              }
            }} data-id="element-276">
                    {item.dropdownType === 'parents' ? <button className="text-sm font-medium text-slate-600 hover:text-[#1a2332] transition-colors flex items-center py-2" data-id="element-277">
                        {item.label}
                        <ChevronDown className="ml-1 h-4 w-4" data-id="element-278" />
                      </button> : <Link to={item.path} className="text-sm font-medium text-slate-600 hover:text-[#1a2332] transition-colors flex items-center py-2" data-id="element-279">
                        {item.label}
                        <ChevronDown className="ml-1 h-4 w-4" data-id="element-280" />
                      </Link>}

                    {/* Programs Dropdown */}
                    {item.dropdownType === 'programs' && isProgramsDropdownOpen && <div className="absolute top-full left-0 pt-2" data-id="element-281">
                          <div className="w-64 bg-white rounded-lg shadow-lg border border-slate-200 py-2" data-id="element-282">
                            {programs.map(program => <Link key={program.id} to={`/programs/${program.id}`} className="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 hover:text-[#1a2332] transition-colors" data-id="element-283">
                                {program.name}
                              </Link>)}
                            <div className="border-t border-slate-200 my-2" data-id="element-284"></div>
                            <Link to="/black-belt-club" className="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 hover:text-[#1a2332] transition-colors" data-id="element-285">
                              Black Belt Club
                            </Link>
                          </div>
                        </div>}

                    {/* Locations Dropdown */}
                    {item.dropdownType === 'locations' && isLocationsDropdownOpen && <div className="absolute top-full left-0 pt-2" data-id="element-286">
                          <div className="w-64 bg-white rounded-lg shadow-lg border border-slate-200 py-2" data-id="element-287">
                            {locations.map(location => <Link key={location.id} to={`/locations/${location.id}`} className="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 hover:text-[#1a2332] transition-colors" data-id="element-288">
                                {location.name}
                              </Link>)}
                          </div>
                        </div>}

                    {/* Parents Dropdown */}
                    {item.dropdownType === 'parents' && isParentsDropdownOpen && <div className="absolute top-full left-0 pt-2" data-id="element-289">
                          <div className="w-64 bg-white rounded-lg shadow-lg border border-slate-200 py-2" data-id="element-290">
                            {parentsDropdownItems.map(parentItem => <Link key={parentItem.path} to={parentItem.path} className="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 hover:text-[#1a2332] transition-colors" data-id="element-291">
                                {parentItem.label}
                              </Link>)}
                          </div>
                        </div>}
                  </div> : <Link key={item.path} to={item.path} className="text-sm font-medium text-slate-600 hover:text-[#1a2332] transition-colors" data-id="element-292">
                    {item.label}
                  </Link>)}
            </nav>

            {/* Phone & CTA - Right Side */}
            <div className="hidden xl:flex items-center gap-4 flex-shrink-0" data-id="element-293">
              <a href={`tel:${GLOBAL_PHONE.replace(/\D/g, '')}`} className="flex items-center text-sm font-medium text-slate-600 hover:text-[#dc2626] transition-colors" data-id="element-294">
                <Phone className="h-4 w-4 mr-2" data-id="element-295" />
                {GLOBAL_PHONE}
              </a>
              <Button variant="primary" size="sm" data-id="element-296">
                Get 2 Weeks Free
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <div className="flex items-center xl:hidden" data-id="element-297">
              <button type="button" className="inline-flex items-center justify-center p-2 rounded-md text-slate-400 hover:text-slate-500 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#1a2332]" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-expanded={isMobileMenuOpen} data-id="element-298">
                <span className="sr-only" data-id="element-299">Open main menu</span>
                {isMobileMenuOpen ? <X className="block h-6 w-6" aria-hidden="true" data-id="element-300" /> : <Menu className="block h-6 w-6" aria-hidden="true" data-id="element-301" />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && <div className="xl:hidden bg-white border-t border-slate-100" data-id="element-302">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-303">
              {/* Phone Number in Mobile Menu */}
              <a href={`tel:${GLOBAL_PHONE.replace(/\D/g, '')}`} className="flex items-center px-3 py-2 rounded-md text-base font-medium text-[#dc2626] hover:bg-slate-50" data-id="element-304">
                <Phone className="h-5 w-5 mr-2" data-id="element-305" />
                {GLOBAL_PHONE}
              </a>

              {navItems.map(item => item.hasDropdown ? <div key={item.path} data-id="element-306">
                    {item.dropdownType === 'parents' ? <div className="block px-3 py-2 rounded-md text-base font-medium text-slate-700" data-id="element-307">
                        {item.label}
                      </div> : <Link to={item.path} className="block px-3 py-2 rounded-md text-base font-medium text-slate-700 hover:text-[#1a2332] hover:bg-slate-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-308">
                        {item.label}
                      </Link>}
                    <div className="pl-6 space-y-1" data-id="element-309">
                      {item.dropdownType === 'programs' && <>
                          {programs.map(program => <Link key={program.id} to={`/programs/${program.id}`} className="block px-3 py-2 rounded-md text-sm text-slate-600 hover:text-[#1a2332] hover:bg-slate-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-310">
                              {program.name}
                            </Link>)}
                          <Link to="/black-belt-club" className="block px-3 py-2 rounded-md text-sm text-slate-600 hover:text-[#1a2332] hover:bg-slate-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-311">
                            Black Belt Club
                          </Link>
                        </>}
                      {item.dropdownType === 'locations' && locations.map(location => <Link key={location.id} to={`/locations/${location.id}`} className="block px-3 py-2 rounded-md text-sm text-slate-600 hover:text-[#1a2332] hover:bg-slate-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-312">
                            {location.name}
                          </Link>)}
                      {item.dropdownType === 'parents' && parentsDropdownItems.map(parentItem => <Link key={parentItem.path} to={parentItem.path} className="block px-3 py-2 rounded-md text-sm text-slate-600 hover:text-[#1a2332] hover:bg-slate-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-313">
                            {parentItem.label}
                          </Link>)}
                    </div>
                  </div> : <Link key={item.path} to={item.path} className="block px-3 py-2 rounded-md text-base font-medium text-slate-700 hover:text-[#1a2332] hover:bg-slate-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-314">
                    {item.label}
                  </Link>)}
              <div className="mt-4 px-3" data-id="element-315">
                <Button variant="primary" className="w-full justify-center" data-id="element-316">
                  Get 2 Weeks Free
                </Button>
              </div>
            </div>
          </div>}
      </header>
    </>;
}